import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

var AppSimpleButton = /*#__PURE__*/function (_Vue) {
  _inherits(AppSimpleButton, _Vue);

  var _super = _createSuper(AppSimpleButton);

  function AppSimpleButton() {
    _classCallCheck(this, AppSimpleButton);

    return _super.apply(this, arguments);
  }

  _createClass(AppSimpleButton, [{
    key: "clickHandler",
    value: function clickHandler() {}
  }, {
    key: "btnType",
    get: function get() {
      switch (this.type) {
        case 'white-outlined':
          return 'c-btn-white-outlined';

        case 'primary':
        default:
          return 'c-btn-primary';
      }
    }
  }]);

  return AppSimpleButton;
}(Vue);

__decorate([Prop(String)], AppSimpleButton.prototype, "label", void 0);

__decorate([Prop(String)], AppSimpleButton.prototype, "type", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppSimpleButton.prototype, "dense", void 0);

__decorate([Emit('click')], AppSimpleButton.prototype, "clickHandler", null);

AppSimpleButton = __decorate([Component], AppSimpleButton);
export default AppSimpleButton;